(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function runColorFilter(colorValue) {
      var gallery = document.querySelector('media-gallery');
      if (!gallery || typeof gallery.filterByColor !== 'function') return;
      var prefix = gallery.dataset.colorMediaPrefix || 'Vocci Ring - ';
      gallery.filterByColor(colorValue, prefix);
    }

    function getSelectedColorInput() {
      return document.querySelector('.vocci-color-input:checked');
    }

    function getSelectedColorValue() {
      var selected = getSelectedColorInput();
      return selected ? selected.value : null;
    }

    // 颜色切换时更新图库
    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('vocci-color-input')) return;
      var gallery = document.querySelector('media-gallery');
      runColorFilter(e.target.value);
      // 标记等待颜色过滤完成，阻止 AJAX 返回后 setActiveMedia 导致的闪烁
      if (gallery) gallery._pendingColorFilter = true;
    });

    // 变体切换后（如尺码变化）重新应用颜色过滤，避免图库显示被重置
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        var colorValue = getSelectedColorValue();
        if (colorValue) runColorFilter(colorValue);
      });
    }

    // 页面加载时对初始选中颜色执行一次过滤
    function initFilter() {
      var colorValue = getSelectedColorValue();
      if (colorValue) runColorFilter(colorValue);
    }

    if (typeof customElements !== 'undefined' && customElements.whenDefined) {
      customElements.whenDefined('media-gallery').then(initFilter);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilter);
    } else {
      initFilter();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // ======== 1. 颜色变体切换逻辑 (事件委托版) ========

    function parseColorTipsMap(raw) {
      var map = {};
      if (!raw) return map;
      raw.split('\n').forEach(function (line) {
        var idx = line.indexOf(':');
        if (idx === -1) return;
        var key = line.slice(0, idx).trim();
        var val = line.slice(idx + 1).trim();
        if (key) map[key] = val;
      });
      return map;
    }

    function updateColorTip(input) {
      var row = input.closest('.vocci-color-row');
      if (!row) return;
      var tipEl = row.querySelector('.vocci-color-item-tip');
      if (!tipEl) return;
      var map = parseColorTipsMap(row.dataset.colorTips);
      var colorName = input.value;
      var tip = map[colorName] || tipEl.dataset.defaultTip || '';
      tipEl.textContent = tip;
    }

    function syncAllColorTips(root) {
      (root || document).querySelectorAll('.vocci-color-input:checked').forEach(updateColorTip);
    }

    // 页面加载时同步初始选中颜色的文案
    syncAllColorTips();

    // ---- 尺码模式状态持久化（应对 AJAX 替换 DOM 后丢失类名的问题）----
    // key: section id, value: 'unknown' | 'select' | null
    var vocciSizeMode = {};

    function applySizeMode(step, mode) {
      if (!step || !mode) return;
      step.querySelectorAll('.vocci-size-mode-btn').forEach(function (btn) {
        btn.classList.toggle('vocci-size-mode-btn--active', btn.dataset.sizeMode === mode);
      });
      step.querySelectorAll('.vocci-size-panel').forEach(function (panel) {
        panel.classList.toggle('vocci-size-panel--visible', panel.dataset.sizePanel === mode);
      });
    }

    // AJAX 恢复时使用：临时抑制 transition，防止 DOM 重建后出现"从默认→选中"的闪烁动画
    function instantApplySizeMode(step, mode) {
      if (!step || !mode) return;
      var btns = step.querySelectorAll('.vocci-size-mode-btn');
      btns.forEach(function (btn) {
        btn.classList.add('vocci-instant');
      });
      btns.forEach(function (btn) {
        btn.classList.toggle('vocci-size-mode-btn--active', btn.dataset.sizeMode === mode);
      });
      step.querySelectorAll('.vocci-size-panel').forEach(function (panel) {
        panel.classList.toggle('vocci-size-panel--visible', panel.dataset.sizePanel === mode);
      });
      // 两帧后恢复 transition（确保当前渲染帧已完成）
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          btns.forEach(function (btn) {
            btn.classList.remove('vocci-instant');
          });
        });
      });
    }

    function restoreAllSizeModes() {
      document.querySelectorAll('variant-selects[data-section]').forEach(function (vs) {
        if (vs.style.display === 'none') return;
        var sectionId = vs.dataset.section;
        var mode = vocciSizeMode[sectionId];
        if (!mode) return;
        vs.querySelectorAll('.vocci-step').forEach(function (step) {
          instantApplySizeMode(step, mode);
          // 恢复 FSK 视觉 checked 状态
          var fskInput = step.querySelector('.vocci-size-input[data-size-type="fsk"]');
          var fskLabel = step.querySelector('.vocci-size-sub-option[data-sub-type="fsk"]');
          if (fskInput && fskLabel) {
            fskLabel.classList.add('vocci-instant');
            fskLabel.classList.toggle('vocci-size-sub-option--checked', fskInput.checked);
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                fskLabel.classList.remove('vocci-instant');
              });
            });
          }
        });
      });
    }

    // variant-selects 被 AJAX 替换后重新同步颜色 tip，并恢复尺码模式
    // viewTransition 先插入新节点再隐藏旧节点，只同步未被隐藏的节点
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function () {
        document.querySelectorAll('.vocci-color-input:checked').forEach(function (input) {
          var vs = input.closest('variant-selects');
          if (vs && vs.style.display === 'none') return;
          updateColorTip(input);
        });
        restoreAllSizeModes();
      });
    }

    document.addEventListener('change', function (e) {
      // 颜色切换
      if (e.target.classList.contains('vocci-color-input')) {
        var fieldset = e.target.closest('.vocci-color-fieldset');
        if (!fieldset) return;
        var items = fieldset.querySelectorAll('.vocci-color-item');
        items.forEach(function (item) {
          item.classList.remove('vocci-color-item--selected');
        });
        var selectedItem = e.target.closest('.vocci-color-item');
        if (selectedItem) {
          selectedItem.classList.add('vocci-color-item--selected');
        }
        return;
      }

      // 尺码选中 → 同步 FSK 视觉状态 + 清除 Instant Self-Measure 激活状态
      if (e.target.classList.contains('vocci-size-input')) {
        var step = e.target.closest('.vocci-step');
        if (step) {
          // FSK 视觉 checked 状态
          var isFsk = e.target.dataset.sizeType === 'fsk';
          var fskLabel = step.querySelector('.vocci-size-sub-option[data-sub-type="fsk"]');
          if (fskLabel) {
            fskLabel.classList.toggle('vocci-size-sub-option--checked', isFsk && e.target.checked);
          }
          // 清除 Instant Self-Measure 激活状态
          step.querySelectorAll('[data-instant-measure-open]').forEach(function (btn) {
            btn.removeAttribute('data-active');
          });
        }
      }

      updateColorTip(e.target);
    });

    // ======== 2. 尺码弹窗与手风琴逻辑 (事件委托版) ========
    // 统一监听整个 document 的 click 事件
    document.addEventListener('click', function (e) {
      // M. 尺码模式切换（"I don't know my size" / "Select your size"）
      var modeBtn = e.target.closest('[data-size-mode]');
      if (modeBtn) {
        var modeStep = modeBtn.closest('.vocci-step');
        if (!modeStep) return;
        var mode = modeBtn.dataset.sizeMode;

        // 持久化模式状态，以便 AJAX 替换 DOM 后可恢复
        var modeVs = modeBtn.closest('variant-selects');
        if (modeVs && modeVs.dataset.section) {
          vocciSizeMode[modeVs.dataset.section] = mode;
        }

        // 应用模式（激活按钮 + 显示面板）
        applySizeMode(modeStep, mode);

        // 切换模式时清空之前的尺码选择
        modeStep.querySelectorAll('.vocci-size-input').forEach(function (input) {
          input.checked = false;
        });
        modeStep.querySelectorAll('[data-instant-measure-open]').forEach(function (btn) {
          btn.removeAttribute('data-active');
        });
        return;
      }

      // N. Instant Self-Measure
      var instantBtn = e.target.closest('[data-instant-measure-open]');
      if (instantBtn) {
        e.preventDefault();
        var instantStep = instantBtn.closest('.vocci-step');
        if (instantStep) {
          // 取消所有尺码输入选中（包括 FSK）
          instantStep.querySelectorAll('.vocci-size-input').forEach(function (input) {
            input.checked = false;
          });
          // 清除 FSK 视觉 checked 状态
          var fskLbl = instantStep.querySelector('.vocci-size-sub-option[data-sub-type="fsk"]');
          if (fskLbl) fskLbl.classList.remove('vocci-size-sub-option--checked');
          // 切换激活状态
          if (instantBtn.hasAttribute('data-active')) {
            instantBtn.removeAttribute('data-active');
          } else {
            instantBtn.setAttribute('data-active', '');
          }
        }
        // 打开自测弹窗
        var imOverlay = document.querySelector('[data-instant-measure-overlay]');
        if (imOverlay) {
          if (imOverlay.parentNode !== document.body) {
            document.body.appendChild(imOverlay);
          }
          imOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      // IM-B. 关闭自测弹窗
      var imCloseBtn = e.target.closest('[data-instant-measure-close]');
      if (imCloseBtn) {
        e.preventDefault();
        var activeImOverlay = document.querySelector('[data-instant-measure-overlay].active');
        if (activeImOverlay) {
          activeImOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
        return;
      }

      // IM-C. 点击遮罩层关闭自测弹窗
      if (e.target.hasAttribute('data-instant-measure-overlay')) {
        e.target.classList.remove('active');
        document.body.style.overflow = '';
        return;
      }

      // IM-D. 自测弹窗手风琴步骤切换（同时更新左侧媒体）
      var imStepToggle = e.target.closest('[data-im-step-toggle]');
      if (imStepToggle) {
        var imStepNum = imStepToggle.dataset.imStepToggle;
        var imModalEl = imStepToggle.closest('[data-instant-measure-overlay], [data-fsk-guide-overlay]');
        if (imModalEl) {
          var targetStep = imModalEl.querySelector('[data-im-step="' + imStepNum + '"]');
          var wasOpen = targetStep && targetStep.hasAttribute('data-open');
          // 关闭所有步骤（手风琴互斥）
          imModalEl.querySelectorAll('.vocci-im-step').forEach(function (s) {
            s.removeAttribute('data-open');
          });
          // 点击已开的则合上，否则展开
          if (!wasOpen && targetStep) {
            targetStep.setAttribute('data-open', '');
          }
        }
        return;
      }

      // IM-E. "Select your size" — 关闭弹窗并激活"选择尺寸"模式
      var selectSizeFromIm = e.target.closest('[data-instant-measure-select-size]');
      if (selectSizeFromIm) {
        // 关闭弹窗
        var closingImOverlay = document.querySelector('[data-instant-measure-overlay].active');
        if (closingImOverlay) {
          closingImOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
        // 找到页面上的"Select your size"模式按钮并触发点击
        document.querySelectorAll('.vocci-size-mode-btn[data-size-mode="select"]').forEach(function (btn) {
          var vs = btn.closest('variant-selects');
          if (vs && vs.style.display !== 'none') btn.click();
        });
        return;
      }

      // A. 打开 size guide 弹窗
      var openBtn = e.target.closest('[data-size-guide-open]');
      if (openBtn) {
        e.preventDefault();
        var overlay = document.querySelector('[data-size-guide-overlay]');
        if (overlay) {
          if (overlay.parentNode !== document.body) {
            document.body.appendChild(overlay);
          }
          overlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      // A2. 打开 Free size kit guide 弹窗
      var fskOpenBtn = e.target.closest('[data-fsk-guide-open]');
      if (fskOpenBtn) {
        e.preventDefault();
        var fskOverlay = document.querySelector('[data-fsk-guide-overlay]');
        if (fskOverlay) {
          if (fskOverlay.parentNode !== document.body) {
            document.body.appendChild(fskOverlay);
          }
          fskOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      // B. 点击关闭按钮 (size guide)
      var closeBtn = e.target.closest('[data-size-guide-close]');
      if (closeBtn) {
        e.preventDefault();
        var activeOverlay = document.querySelector('[data-size-guide-overlay].active');
        if (activeOverlay) {
          activeOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
        return;
      }

      // B2. 点击关闭按钮 (Free size kit guide)
      var fskCloseBtn = e.target.closest('[data-fsk-guide-close]');
      if (fskCloseBtn) {
        e.preventDefault();
        var activeFskOverlay = document.querySelector('[data-fsk-guide-overlay].active');
        if (activeFskOverlay) {
          activeFskOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
        return;
      }

      // C. 点击半透明遮罩层关闭弹窗
      if (e.target.hasAttribute('data-size-guide-overlay') || e.target.hasAttribute('data-fsk-guide-overlay')) {
        e.target.classList.remove('active');
        document.body.style.overflow = '';
        return;
      }

      // D. 弹窗内的手风琴互斥逻辑
      var summary = e.target.closest('.vocci-sg-accordion__header');
      if (summary) {
        var accordion = summary.closest('.vocci-sg-accordion');
        var parentOverlay = summary.closest('[data-size-guide-overlay], [data-fsk-guide-overlay]');

        if (accordion && !accordion.hasAttribute('open') && parentOverlay) {
          var accordions = parentOverlay.querySelectorAll('.vocci-sg-accordion');
          accordions.forEach(function (otherAccordion) {
            if (otherAccordion !== accordion && otherAccordion.hasAttribute('open')) {
              otherAccordion.removeAttribute('open');
            }
          });
        }
      }
    });

    // ======== 3. ESC 键关闭弹窗逻辑 ========
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var activeOverlay = document.querySelector(
          '[data-size-guide-overlay].active, [data-fsk-guide-overlay].active, [data-instant-measure-overlay].active'
        );
        if (activeOverlay) {
          activeOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      }
    });

    // ======== 4. 尺码强制选择逻辑 ========
    function getProductInfo(el) {
      return (el && el.closest('product-info')) || document.querySelector('product-info');
    }

    function shouldRequireExplicitSize() {
      var productInfo = document.querySelector('product-info');
      var hasFlag = productInfo && productInfo.dataset.requireExplicitSize === 'true';
      if (!hasFlag) {
        // 初次加载：URL 没有 variant 参数则需要强制选择
        return !new URLSearchParams(window.location.search).has('variant');
      }
      // flag 已设置（初次清空后）：只有当前没有任何 size 被选中时才需要强制重选
      // 这样用户选了 FSK/数字 size 后，product-info:loaded 不会再次清空
      return !document.querySelector('.vocci-size-input:checked');
    }

    function clearSizeSelection(root) {
      var scope = root || document;
      scope.querySelectorAll('.vocci-size-input').forEach(function (input) {
        input.checked = false;
      });
      scope.querySelectorAll('[data-instant-measure-open][data-active]').forEach(function (btn) {
        btn.removeAttribute('data-active');
      });
      scope.querySelectorAll('.vocci-size-sub-option--checked').forEach(function (label) {
        label.classList.remove('vocci-size-sub-option--checked');
      });
    }

    function initSizeRequiredState() {
      if (!shouldRequireExplicitSize()) return;
      clearSizeSelection(document);
      var productInfo = document.querySelector('product-info');
      if (productInfo) {
        productInfo.setAttribute('data-require-explicit-size', 'true');
      }
      var productForm = document.querySelector('product-info product-form');
      if (productForm && typeof productForm.toggleSubmitButton === 'function') {
        productForm.toggleSubmitButton(true);
      }
    }

    initSizeRequiredState();
    document.addEventListener('product-info:loaded', function () {
      restoreAllSizeModes();
      initSizeRequiredState();
    });

    // 捕获阶段：在 variant-selects 读取选项前清空尺码，并重置模式按钮
    document.addEventListener(
      'change',
      function (e) {
        if (!e.target.classList.contains('vocci-color-input')) return;
        var productInfo = getProductInfo(e.target);
        // 已选中尺码时保留选择：checked 的 size input 会随请求带上 option id，
        // 服务端重新渲染后该尺码仍为选中状态；模式面板由 vocciSizeMode 恢复
        var checkedSize = (productInfo || document).querySelector('.vocci-size-input:checked');
        if (checkedSize) return;
        clearSizeSelection(productInfo);
        var scope = productInfo || document;
        scope.querySelectorAll('.vocci-size-mode-btn').forEach(function (btn) {
          btn.classList.remove('vocci-size-mode-btn--active');
        });
        scope.querySelectorAll('.vocci-size-panel').forEach(function (panel) {
          panel.classList.remove('vocci-size-panel--visible');
        });
        // 颜色切换后清除持久化的模式记录
        scope.querySelectorAll('variant-selects[data-section]').forEach(function (vs) {
          delete vocciSizeMode[vs.dataset.section];
        });
      },
      true
    );
  });
  } catch(e) { console.error(e); }
})();

})();
